import React from 'react';
import './App.css';
import AppHeader from './AppHeader';
import AppRouter from './routes/AppRouter';
import AppFooter from './AppFooter';
import { AuthProvider } from '../stores/auth';

function App() {
  return (
    <AuthProvider>
      <div className="app-container">
        <AppHeader title='Home on Second App' />
        <main className='app-main-content' >
          <AppRouter />
        </main>
        <AppFooter />
      </div>
    </AuthProvider>
  );
}

export default App;
